import React, { useEffect } from "react";

import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, { animationCleanUp } from "./animation";

import assets from "./assets";
import { useTranslation } from "react-i18next";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/Index";

import "./style/style.scss";
import "./style/animation.scss";
import { PlayerTriko } from "../../_partials/PlayerTriko/Index";
import getContentById from "../../../../shared/utils/getContentById";
import bild_zone_pitch from "../../../assets/wc/videos/goal.webm";
import { BildPlayerTriko } from "../../_partials/BildPlayerTriko/Index";

const getMainBackground = () => {
  return assets.background_1920;
};

const radius = 50;
const goalRadius = 50;
const width = 1385;
const height = 800;

function getCssBottom(x, r = radius) {
  return height * (x - 50) / 50 - r;
}

function getCssRight(y, r = radius) {
  return (y / 100) * width - r
}

function getSvgX(y, r) {
  return width - getCssRight(y, r) - r;
}

function getSvgY(x, r) {
  return height - getCssBottom(x, r) - r;
}

function getSvgPoint(x, y, r = radius) {
  return `${getSvgX(y, r)},${getSvgY(x, r)}`;
}

export default function Index({ animation, data, mode, format, startAnimation, ...props }) {
  const { t } = useTranslation();

  const id = `T_bild_goal_alarm_goal`;
  const isTimeline = props.isTimeline;

  const onlyData = data;
  const matchInfo = onlyData?.matchInfo;
  const matchDetails = onlyData?.matchDetails;

  const goalData = onlyData?.goalData?.goalCoordData || [];
  const goal = goalData?.[goalData?.length - 1];
  const isGoalPenalty = goalData?.isPenalty !== undefined ? goalData?.isPenalty : goal?.isPenalty ? goal?.isPenalty : onlyData?.updater?.isPenalty !== undefined ? onlyData?.updater?.isPenalty : false;
  const competitionId = matchInfo?.competition?.id;
  const matchStatus = matchDetails?.matchStatus;
  const scores = matchDetails?.scores;
  const reversePlayerMapping = _.get(onlyData, "reversePlayerMapping");
  const heimspielMatch = _.get(onlyData, "heimspielMatch");
  const homeTeam = matchInfo?.contestant?.[0];
  const awayTeam = matchInfo?.contestant?.[1];
  const scorerTeamId = goal?.teamId;
  const teamSide = goal?.isOwnGoal ? homeTeam.id === scorerTeamId ? 'away' : 'home' : homeTeam.id === scorerTeamId ? 'home' : 'away';
  const heimspielHome = heimspielMatch?.home;
  const heimspielAway = heimspielMatch?.away;
  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };
  useEffect(() => {
    let animationReturn = null;
    if (!startAnimation) return;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          data: data, // data,
          animation,
          mode,
          id,
          format,
          apiSetup: props?.apiSetup,
          templateName: data?.template_name,
        });

        animationReturn.timeline.play();
      }
    }

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode, startAnimation]);


  const goalPos = goal?.coords?.dest;
  const goalEventId = goal?.eventId;
  return (
    <div
      id={id}
      className={`${id} ${animation ? "animation" : ""} side-${teamSide}`}
    >
      <TemplateBlock class={`${isTimeline ? "" : "template-bild"}`} style={{ backgroundColor: 'rgb(253, 188, 1) !important' }}>
        {/* {
          !isTimeline && <div className="main-header-content">
            <div className="main-header">
              {t("wc_goal.headline", { keyPrefix: "templates" })}{" "}
              {goal?.isOwnGoal ? (
                <div className={"own-goal-marker"}>({t("Own goal")})</div>
              ) : null}
            </div>
            <MatchScoreWidget
              homeTeam={homeTeam}
              awayTeam={awayTeam}
              scores={scores}
              matchStatus={matchStatus}
              matchDetails={matchDetails}
              competitionId={competitionId}
              matchInfo={matchInfo}
            />
          </div>
        } */}
        {matchStatus && goal && (
          <div className="wc-content wc-content-v2" style={{ top: 160 }}>
            <div className="main-content-side">
              <div className={"left-block-side"}>
                <BildPlayerTriko
                  className={"left-player"}
                  player={{
                    knownName: goal?.player?.matchName,
                    ...goal?.player,
                    person: {
                      ...goal?.player,
                      surname: goal?.player?.shortLastName,
                      id: reversePlayerMapping?.[goal?.player?.playerId]
                    }
                  }}
                  // position={goal?.player?.position}
                  position={t(goal?.player?.position === "Substitute" ? goal?.player?.subPosition : goal?.player?.position, {keyPrefix: "templates"}) }
                  teamId={homeTeam?.id}
                  side={"home"}
                  bgColor={goal?.kit?.colour1}
                  team={teamSide === "home" ? heimspielHome : heimspielAway}
                  competitionId={competitionId}
                />
                <div className="left-block-shadow"></div>
              </div>

              <div className={"center-block-side"}>
                <video
                  className="video-pitch"
                  width="100%"
                  height="100%"
                  controls={false}
                  muted={true}
                  autoPlay={false}
                  loop={false}>
                  <source src={bild_zone_pitch} type="video/mp4" />
                </video>
                <div className="right">
                  <div className="pitch-container">
                    <div
                      className="pitch"
                    // style={{ backgroundImage: `url(${assets.pitch})` }}
                    >

                      {!isGoalPenalty && goalData.map((data) => {
                        return (
                          <div
                            className={`circle eventid-${data?.eventId} ${data?.typeId === 16 ? "shooter" : undefined}`}
                            id={`player-${data?.eventId}-${data?.typeId}`}
                            key={`${data?.eventId}`}
                            style={{
                              bottom: getCssBottom(data?.x),
                              right: getCssRight(data?.y, radius),
                              backgroundColor: (data?.isPlayerOpposite || data?.isOwnGoal) ? 'blue' : '#c80001',
                            }}
                          >
                            {data?.player?.shirtNumber}
                          </div>
                        );
                      })}
                      {isGoalPenalty && (
                        <div
                          className={`circle eventid-${goal?.eventId} ${goal?.typeId === 16 ? "shooter" : undefined}`}
                          id={`player-${goal?.eventId}-${goal?.typeId}`}
                          key={`${goal?.eventId}`}
                          style={{
                            bottom: getCssBottom(goal?.x),
                            right: getCssRight(goal?.y, radius),
                          }}
                        >
                          {goal?.player?.shirtNumber}
                        </div>
                      )}
                      <img
                        src={assets.ball}
                        className={`circle goal eventid-${goalEventId}`}
                        id={`goal`}
                        style={{
                          backgroundImage: `url(${assets.ball}`,
                          bottom: height - goalRadius * 2,
                          right: getCssRight(goalPos?.y, goalRadius),
                        }}
                      ></img>
                      <svg>
                        {goalData.map((data, index, array) => {
                          const nextPlayer = array[index + 1];

                          //typeId 16 === Goal
                          const destRadius =
                            data.typeId === 16 ? goalRadius : radius;
                          if (data.typeId === 16) {
                            return (
                              <path
                                id={`path-${data.eventId}-${data.typeId}`}
                                className={`path event-${data.typeId}`}
                                key={`${data.x}-${data.y}`}
                                d={`M${getSvgPoint(data.x, data.y)} ${getSvgPoint(100 - 3, data?.coords?.dest.y, destRadius)}z`}
                              />
                            );
                          }

                          const pathStyle = {};

                          // Conditionally add dotted style property
                          if (data.player?.shirtNumber == nextPlayer?.player?.shirtNumber) {
                            pathStyle.strokeDasharray = '6, 18';
                          }
                          if (!isGoalPenalty) {
                            return (
                              <path
                                id={`path-${data.eventId}-${data.typeId}`}
                                className={`path event-${data.typeId}`}
                                key={`${data.x}-${data.y}`}
                                d={`M${getSvgPoint(data.x, data.y)} ${getSvgPoint(data.coords.dest.x, data.coords.dest.y, destRadius)}z`}
                                style={pathStyle}
                              />
                            );
                          }
                        })}
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </TemplateBlock>
    </div>
  );
}
